import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Forbidden = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirection vers la page d'accueil après 5 secondes
    const redirectTimer = setTimeout(() => {
      navigate("/admin/default");
    }, 2000);

    // Cleanup du timer si le composant est démonté
    return () => clearTimeout(redirectTimer);
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100">
      <div className="rounded-lg bg-white p-8 shadow-md">
        <h1 className="mb-4 text-4xl font-bold text-red-600">
          403 - Accès Interdit
        </h1>
        <p className="mb-4 text-gray-700">
          Vous n'avez pas la permission d'accéder à cette page.
        </p>
        <p className="text-sm text-gray-500">
          Redirection vers la page d'accueil dans quelques secondes...
        </p>
      </div>
    </div>
  );
};

export default Forbidden;
